import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const tabs = [
  {
    id: 'fernanda',
    name: 'Fernanda',
    sub: '3 a 4 rec · 143 m² · roof garden',
    poster: '/images/real/sm-fer-twilight-01-lg.webp',
    matterport: 'https://my.matterport.com/show/?m=tBsE9SN6rZz&play=1&qs=1&hr=0&brand=0',
    accent: '#f6802c',
    specs: {
      lote: '127.5 m²',
      construccion: '143 m²',
      recamaras: '3 a 4',
      banos: '2.5',
      cochera: '2 autos',
      niveles: '3',
    },
    extras: ['Jardín posterior', 'Walk-in closet en master', 'Cocina integral', 'Roof garden'],
    link: '/modelo-fernanda',
  },
  {
    id: 'mariana',
    name: 'Mariana',
    sub: '3 a 4 rec · 163 m² · roof garden',
    poster: '/images/real/sm-mar-twilight-01-lg.webp',
    matterport: 'https://my.matterport.com/show/?m=HMmqeW2B4t7&play=1&qs=1&hr=0&brand=0',
    accent: '#f6802c',
    specs: {
      lote: '127.5 m²',
      construccion: '163 m²',
      recamaras: '3 a 4',
      banos: '3 + 2 medios',
      cochera: '2 autos',
      niveles: '3',
    },
    extras: ['Jardín posterior', 'Walk-in closet en master', 'Cocina integral', 'Roof garden'],
    link: '/modelo-mariana',
  },
];

const specRows = [
  { key: 'lote', label: 'Lote tipo', icon: 'crop_landscape' },
  { key: 'construccion', label: 'Construcción', icon: 'square_foot' },
  { key: 'recamaras', label: 'Recámaras', icon: 'bed' },
  { key: 'banos', label: 'Baños', icon: 'shower' },
  { key: 'cochera', label: 'Cochera', icon: 'directions_car' },
  { key: 'niveles', label: 'Niveles', icon: 'stairs' },
];

export default function VirtualTour() {
  const [active, setActive] = useState('fernanda');
  const [playing, setPlaying] = useState(false);
  const current = tabs.find((t) => t.id === active);

  const handleSwitch = (id) => {
    setPlaying(false);
    setActive(id);
  };

  return (
    <section id="recorrido-virtual" className="vtour-section" data-testid="vtour-section">
      <div className="page-padding">
        <div className="container-large">
          <div className="vtour-head">
            <div className="text-label" style={{ color: 'rgba(255,255,255,0.55)' }}>recorrido virtual · comparador</div>
            <h2 className="sm-h2" data-reveal>
              Camina por tu <span className="serif-accent">próximo hogar.</span>
            </h2>
            <p className="text-size-medium" data-reveal style={{ maxWidth: '640px', color: 'rgba(255,255,255,0.85)' }}>
              Recorre cada habitación desde donde estés y compara las características de cada modelo.
              Encuentra el que mejor se adapta a tu estilo de vida.
            </p>
          </div>

          <div className="vtour-tabs" data-testid="vtour-tabs">
            {tabs.map((t) => (
              <button
                key={t.id}
                className={`vtour-tab${active === t.id ? ' active' : ''}`}
                onClick={() => handleSwitch(t.id)}
                style={{ '--tab-accent': t.accent }}
                data-testid={`vtour-tab-${t.id}`}
              >
                <span className="vtour-tab-name">Modelo {t.name}</span>
                <span className="vtour-tab-sub">{t.sub}</span>
              </button>
            ))}
          </div>

          <div className="vtour-grid">
            {/* IZQUIERDA — Video / Matterport */}
            <div className="vtour-stage-col">
              <div className="vtour-stage" data-testid="vtour-stage">
              {!playing ? (
                <button
                  className="vtour-poster"
                  onClick={() => setPlaying(true)}
                  style={{ backgroundImage: `url(${current.poster})` }}
                  data-testid="vtour-play-btn"
                  aria-label={`Reproducir tour de ${current.name}`}
                >
                  <div className="vtour-poster-overlay" />
                  <div className="vtour-play-circle">
                    <span className="icon-font">play_arrow</span>
                  </div>
                  <div className="vtour-poster-meta">
                    <div className="vtour-poster-label">Recorrido virtual</div>
                    <div className="vtour-poster-name">{current.name}</div>
                  </div>
                  <div className="vtour-360-badge">
                    <span className="icon-font">view_in_ar</span>
                    <span>Tour 360°</span>
                  </div>
                </button>
              ) : (
                <div className="vtour-iframe-wrap">
                  <button
                    className="vtour-close"
                    onClick={() => setPlaying(false)}
                    aria-label="Cerrar"
                    data-testid="vtour-close"
                  >
                    <span className="icon-font">close</span>
                  </button>
                  <iframe
                    src={current.matterport}
                    title={`Tour 3D ${current.name}`}
                    allow="autoplay; fullscreen; xr-spatial-tracking; accelerometer; gyroscope"
                    allowFullScreen
                  />
                </div>
              )}
              </div>

              <div className="vtour-perks">
                <div className="vtour-perk">
                  <span className="icon-font">hd</span>
                  <span>Calidad HD</span>
                </div>
                <div className="vtour-perk">
                  <span className="icon-font">phone_iphone</span>
                  <span>Compatible con celular</span>
                </div>
                <div className="vtour-perk">
                  <span className="icon-font">vrpano</span>
                  <span>Vista 360°</span>
                </div>
                <div className="vtour-perk">
                  <span className="icon-font">schedule</span>
                  <span>3 minutos por modelo</span>
                </div>
              </div>
            </div>

            {/* DERECHA — Specs del modelo activo */}
            <aside className="vtour-specs" data-testid={`vtour-specs-${current.id}`}>
              <div className="vtour-specs-header" style={{ borderColor: current.accent }}>
                <h3 className="vtour-specs-name">Modelo {current.name}</h3>
                <Link
                  to={current.link}
                  className="vtour-specs-cta"
                  style={{ color: current.accent }}
                  data-testid={`vtour-cta-${current.id}`}
                  aria-label={`Ver modelo ${current.name}`}
                >
                  Ver modelo
                  <span className="icon-font">arrow_forward</span>
                </Link>
              </div>

              <ul className="vtour-specs-list">
                {specRows.map((row) => (
                  <li key={row.key} className={row.highlight ? 'highlight' : ''}>
                    <span className="icon-font vtour-specs-icon">{row.icon}</span>
                    <span className="vtour-specs-label">{row.label}</span>
                    <span className="vtour-specs-value">{current.specs[row.key]}</span>
                  </li>
                ))}
              </ul>

              <div className="vtour-specs-extras">
                {current.extras.map((e, i) => (
                  <span key={i} className="vtour-specs-extra">
                    <span className="icon-font">check_circle</span>{e}
                  </span>
                ))}
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}
